import { action, makeObservable, observable } from 'mobx';
import { State, updateSelectedOption, SortOption } from './Types';

class SortStore {
  @observable
  state: State;

  constructor(sortOption: SortOption) {
    makeObservable(this);

    this.state = updateSelectedOption(sortOption);
  }

  @action
  updateSelectedValue = (value: SortOption) => {
    this.state = updateSelectedOption(value);
  };
}

export default SortStore;
